//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { IReportTeacherIDsInputItem } from './IReportTeacherIDsInputItem';
import { ReportType } from './Enums';

export class PayrollReportInputItem extends ReportInputItem implements IReportDateRangeInputItem, IReportTeacherIDsInputItem {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    TeacherIDs: string[] = [];
    IncludeBalanceForwardAndPayments: boolean = false;
    IncludeDeductionSummary: boolean = false;
    IncludeTotalHours: boolean = false;
    IncludePayrollDetails: boolean = false;
    IncludeAttendance: boolean = false;
    PageBreakAfterTeacher: boolean = false;
    FormatForDuplexPrinting: boolean = false;
    override readonly Type: ReportType = ReportType.Payroll;

    constructor(initializer?: Partial<Omit<PayrollReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "PayrollReportInputItem";
}
